import { render, staticRenderFns } from "./UpdatePermission.vue?vue&type=template&id=3906d8d1&"
import script from "./UpdatePermission.vue?vue&type=script&lang=js&"
export * from "./UpdatePermission.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePermission.vue?vue&type=style&index=0&id=3906d8d1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports